module.exports = __webpack_public_path__ + "static/media/CFA_branded_Side_Panel.79d9a865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CFA_branded_Side_Panel.png
// module id = 229
// module chunks = 0